function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M304,304.808V232c0-13.232-10.768-24-24-24H56c-13.232,0-24,10.768-24,24v72.808C13.768,308.528,0,324.688,0,344v48v80 c0,4.416,3.584,8,8,8h32c4.416,0,8-3.584,8-8v-24h240v24c0,4.416,3.584,8,8,8h32c4.416,0,8-3.584,8-8v-80v-48 C336,324.688,322.232,308.528,304,304.808z M48,232c0-4.408,3.592-8,8-8h224c4.408,0,8,3.592,8,8v72h-16v-32 c0-13.232-10.768-24-24-24h-48c-13.232,0-24,10.768-24,24v32h-16v-32c0-13.232-10.768-24-24-24H88c-13.232,0-24,10.768-24,24v32 H48V232z M256,272v32h-64v-32c0-4.408,3.592-8,8-8h48C252.408,264,256,267.592,256,272z M144,272v32H80v-32c0-4.408,3.592-8,8-8 h48C140.408,264,144,267.592,144,272z M320,464h-16v-24c0-4.416-3.584-8-8-8H40c-4.416,0-8,3.584-8,8v24H16v-64h304V464z M320,384 H16v-40c0-13.232,10.768-24,24-24h32h80h32h80h32c13.232,0,24,10.768,24,24V384z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M472,304H360c-4.416,0-8,3.584-8,8v64v56h16v-48h96v48h16v-56v-64C480,307.584,476.416,304,472,304z M464,368h-96v-48h96 V368z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 400,
  y: 336,
  width: 32,
  height: 16
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M455.592,237.464l-16-48C438.496,186.2,435.448,184,432,184h-32c-3.448,0-6.496,2.2-7.592,5.472l-16,48 c-0.816,2.44-0.4,5.12,1.104,7.208c1.504,2.088,3.92,3.32,6.488,3.32h24v24h-16v16h48v-16h-16v-24h24 c2.568,0,4.984-1.232,6.488-3.328C455.992,242.584,456.4,239.904,455.592,237.464z M395.096,232l10.672-32h20.472l10.664,32 H395.096z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M475.272,104.696l-232-104c-2.088-0.928-4.464-0.928-6.544,0l-232,104C1.848,105.992,0,108.848,0,112v96h16v-90.824 L240,16.768l224,100.416V208h16v-96C480,108.848,478.152,105.992,475.272,104.696z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M295.224,110.672l-15.784,2.656c0.376,2.184,0.56,4.424,0.56,6.672c0,22.056-17.944,40-40,40c-22.056,0-40-17.944-40-40 c0-22.056,17.944-40,40-40c4.576,0,9.072,0.768,13.344,2.28l5.328-15.088C252.68,65.072,246.4,64,240,64c-30.88,0-56,25.12-56,56 s25.12,56,56,56s56-25.12,56-56C296,116.864,295.736,113.728,295.224,110.672z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M290.344,66.344L240,116.688l-10.344-10.344l-11.312,11.312l16,16c1.56,1.56,3.608,2.344,5.656,2.344 c2.048,0,4.096-0.784,5.656-2.344l56-56L290.344,66.344z"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      "enableBackground": "new 0 0 480 480"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

export default __webpack_public_path__ + "static/media/hotel.6f516fd9.svg";
export { SvgComponent as ReactComponent };